import type { AgentV2UIState } from '@/agent-v2/store/schemas'
import { type ContentViewerSession, ViewerDocumentKind, ViewerOpenContextKind } from '@/content-viewer/store/schemas'

export function buildUIState({
  sourceSession,
  tableId,
  artifactId,
}: {
  sourceSession: ContentViewerSession | null
  tableId?: string
  artifactId: string | null
}): AgentV2UIState {
  return {
    file_id: sourceSession?.document.kind === ViewerDocumentKind.USER_FILE ? sourceSession.document.userFileId : null,
    reference_id: sourceSession?.context.kind === ViewerOpenContextKind.CHAT_CITATION ? sourceSession.context.citationId : null,
    table_id: tableId ?? null,
    artifact_id: artifactId,
  }
}
